import React from 'react'
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import { useDispatch, useSelector } from 'react-redux';
import { examUpdate } from '../../../../redux/actions/exam/examActions';
import { examFieldModelName, examImportFieldName, examFieldsConvert, additionalTestFieldIndex } from '../../../../itrust_common/components/HelperFunctions';
import { syncImportedContactLensPrescription } from './syncContactLensPrescriptionImport';
import * as $ from 'jquery';

const FORM_NAME = 'examFinalizePrescriptionForm';

const PRESCRIPTION_FIELDS = {
  contact_lens_prescription: 'finalized_lenses_attributes',
  eye_glass_prescription: 'finalized_glasses_attributes',
};

const getOverviewId = (overviewName) => (
  typeof overviewName === 'string' ? overviewName : overviewName?.id
);

const getRecordId = (prevExam, overviewId) => {
  if (!overviewId || !prevExam) return;

  const attribute = examFieldsConvert(overviewId);
  const modelName = examFieldModelName(overviewId);

  switch (modelName) {
    case 'Exam::Examination':
      return prevExam.id;
    case 'Exam::AdditionalTest':
      return prevExam.additional_tests_attributes?.[additionalTestFieldIndex(attribute)]?.id;
    default: {
      const data = prevExam[attribute];
      return Array.isArray(data) ? data[0]?.id : data?.id;
    }
  }
};

export default function OldValuesHeader(props) {
  const { prevExam, overviewName, examId, importIds, importSourceLenses } = props;
  const dispatch = useDispatch();
  const formValues = useSelector(state => state.form?.[FORM_NAME]?.values || {});
  const exam = useSelector(state => state.exam?.exam || {});
  const overviewId = getOverviewId(overviewName);
  const recordId = getRecordId(prevExam, overviewId);
  let recordIds = null;
  if (importIds?.length) {
    recordIds = importIds;
  } else if (recordId) {
    recordIds = [recordId];
  }
  const isProcedureOrImpression = overviewId === 'procedure' || overviewId === 'impression';
  const prescriptionField = PRESCRIPTION_FIELDS[overviewId];

  const preparePrescriptionImport = () => {
    if (!prescriptionField) return Promise.resolve();

    const entries = formValues[prescriptionField] ?? exam[prescriptionField] ?? [];
    const newEntry = entries.length
      ? { ...entries[entries.length - 1], id: null }
      : { id: null };

    return dispatch(examUpdate({
      id: examId,
      finalized_lenses_attributes: prescriptionField === 'finalized_lenses_attributes'
        ? [...entries, newEntry]
        : (formValues.finalized_lenses_attributes ?? exam.finalized_lenses_attributes ?? []),
      finalized_glasses_attributes: prescriptionField === 'finalized_glasses_attributes'
        ? [...entries, newEntry]
        : (formValues.finalized_glasses_attributes ?? exam.finalized_glasses_attributes ?? []),
    }, { include: '*' }));
  };

  const handleImport = () => {
    if (!overviewId || !examId) return;

    if (isProcedureOrImpression) {
      if (!importIds?.length) return;

      const importKey = overviewId === 'procedure' ? 'import_procedure_ids' : 'import_impression_ids';
      dispatch(examUpdate({ id: examId, [importKey]: importIds }, { include: '*' }))
        .then(() => $(`#${overviewId}`).modal('toggle'));
      return;
    }

    if (!recordIds?.length) return;

    const modelName = examFieldModelName(overviewId);
    const importHash = {
      model_name: modelName,
      record_id: recordIds,
      import_field: examImportFieldName(overviewId),
    };

    if (modelName === 'Exam::AdditionalTest') {
      importHash.images = ['images1', 'images2'];
    } else if (modelName === 'Exam::Keratometry') {
      importHash.images = ['od_topography_images', 'os_topography_images'];
    }

    const runImport = () => dispatch(examUpdate({
      id: examId,
      import_exam_data_hash: importHash,
    }, { include: '*' }));

    const finishImport = () => {
      if (overviewId === 'contact_lens_prescription') {
        syncImportedContactLensPrescription(dispatch, importSourceLenses || []);
      }
      $(`#${overviewId}`).modal('toggle');
    };

    if (prescriptionField) {
      preparePrescriptionImport().then(runImport).then(finishImport);
    } else {
      runImport().then(finishImport);
    }
  };

  const showImport = isProcedureOrImpression
    ? !!importIds?.length
    : !!(overviewId && examId && recordIds?.length);

  return (
    <div className="col-12 py-4 border-bottom mb-4">
      <div className="d-flex align-items-center justify-content-between">
        <h6>
          {prevExam.provider_name} - <DateFormatView date={prevExam.exam_date} />
          {recordIds?.length === 1 && (
            <span className="text-muted ml-2">- Record ID: {recordIds[0]}</span>
          )}
        </h6>
        {showImport && (
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleImport}>
            Import
          </button>
        )}
      </div>
    </div>
  )
}
